import { useSelector } from 'react-redux';
import { getNCFileById } from '@reducers/manufacture';
import { selectNcFileData, setNcFileData } from '@reducers/details';
import { useAppDispatch } from '@store/hooks/useAppDispatch';
import { NcFile } from '@api/domain';
import { useFetch } from '@api/hooks';

interface UseGetNCFileByIdParams {
  id: number | null;
}

export const useGetNCFileById = ({ id }: UseGetNCFileByIdParams) => {
  const dispatch = useAppDispatch();
  const ncFileData = useSelector(selectNcFileData)?.data;

  const { loading, refetch } = useFetch<NcFile>({
    fetchFn: async () => {
      if (!id) return null;
      const ncFile = (await dispatch(getNCFileById(id))) ?? null;
      // Persist to shared details.ncFileData so other consumers (machines/batch/details) stay in sync.
      dispatch(setNcFileData(ncFile));
      return ncFile;
    },
    deps: [id],
  });

  return { ncFileData, loading, refetch };
};
